export default {
    namespaced: true,
    state: () => ({
        search: '',
        tableOptions:
        {
            page: 1,
            itemsPerPage : 15,
            sortBy : [ "controldate" ],
            sortDesc : [ true ],
            groupBy : [],
            groupDesc : [],
            multiSort : false,
            mustSort : false
        },
    }),
    mutations: {
        SET_SEARCH (state, payload){
            state.search = payload;
        },
        SET_TABLE_OPTION (state, payload) {
            state.tableOptions = payload;
        },
        SET_TABLE_OPTION_PAGE (state, payload) {
            state.tableOptions.page = payload;
        }
    },
    getters: {
        getSearch: (state) => state.search,
        getTableOptions: (state) => state.tableOptions,
    }
}